import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Container, Grid } from '@material-ui/core';
import ClientUserEdit from './components/ClientUserEditPage';
import ClientEditSidebar, {
    ACTIVE_CLIENT_SIDEBAR_TAB_NAMES
} from '../clientedit/ClientEditSidebar';
import { useSwaggerClient } from '../../../hooks/useSwaggerClient';
import { useModals, MODAL_TYPE } from '../../../hooks/useModal';
import { setGuestFields } from '../../../hooks/useGuestFields';

function ClientUserPage({ updateGuest }) {
    const { clientId } = useParams();
    const { userId } = useParams();
    const { showModal } = useModals();
    const [guestFieldsForClient, setGuestFieldsForClient] = useState([]);

    const [user, loadingUser, errorUser, setUser] = useSwaggerClient(
        'users',
        'getUserById',
        { userId: userId },
        [userId]
    );

    useEffect(() => {
        const guestFields = [
            ...(user?.guest?.guest_field_info || []),
            ...(user?.clientGuestFields || [])
        ];

        const uniqueGuestFields = Array.from(
            new Map(guestFields.map(field => [field.id, field])).values()
        );
        setGuestFieldsForClient(uniqueGuestFields);
    }, [user]);

    // Edit user data
    const openUserEditModal = useCallback(() => {
        showModal(MODAL_TYPE.CREATE_OR_UPDATE_GUEST, {
            customer: {
                ...user.guest
            },
            id: userId,
            guest_fields: guestFieldsForClient,
            isAgent: true,
            handleSubmit: editedUser => {
                // forcefully override id, so we can send in 'me' when editing own profile
                updateGuest({ ...editedUser });
                setUser({ ...user, guest: editedUser });
                // close modal
                showModal(MODAL_TYPE.NONE);
            }
        });
    }, [showModal, user, updateGuest, userId]);

    return (
        <Container fixed className="activity-edit page">
            <Grid className="pageWithSidebar">
                <ClientEditSidebar activeTab={ACTIVE_CLIENT_SIDEBAR_TAB_NAMES.users} />
                <Grid className="pageContent">
                    <ClientUserEdit
                        clientId={clientId}
                        user={user}
                        openUserEditModal={openUserEditModal}
                        loadingUser={loadingUser}
                        errorUser={errorUser}
                        setUser={setUser}
                    />
                </Grid>
            </Grid>
        </Container>
    );
}

export default ClientUserPage;
